<template>
  <div>
    <Echart id="centreLeft2Chart" ref="centreLeft3ChartRef" :options="options" height="480px" width="100%"></Echart>
  </div>
</template>

<script>
  import Echart from '@/common/echart';
  export default {
    data() {
      return {
        options: {},
      };
    },
    components: {
      Echart,
    },
    props: {
      cdata: {
        type: Array,
        default: () => [],
      },
    },
    watch: {
      cdata: {
        handler(newData) {
         this.options = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: [{
              type: 'category',
              data: ['日', '周', '月'],
              axisTick: {
                alignWithLabel: true
              }
            }],
            yAxis: [{
              type: 'value'
            }],
            series: [{
              name: '咨询量',
              type: 'bar',
              barWidth: '60%',
              data: newData,
              label: {
                show: true,
              }
            }]
          }
        },
        immediate: true,
        deep: true,
      },
    },
    methods: {

    },
  };
</script>